import requester from '@/lib/axios';
import { KlassesPendingSummaryTotal } from '@/models/Statistics';
import { ListKlassesFilters } from '@/data/services/klassServices';

export type KlassesPendingSummaryTotalFilters = Pick<
  ListKlassesFilters,
  'id' | 'teacherId' | 'unitId'
>;

export const getKlassesPendingSummaryTotal = async (
  params: KlassesPendingSummaryTotalFilters = {},
) => {
  const { data } = await requester().get<KlassesPendingSummaryTotal>(
    'analytics/classes/pending-summary/total/',
    { params },
  );

  return data;
};
